/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('tags', ['$parse', 'CONFIG', function ($parse, CONFIG) {
        return {
            restrict: 'A',
            templateUrl: 'partials/card/tags',
            scope: {
                tags: '=tags',
            },
            link: function (scope, element, attributes) {
                var tags = scope.tags, poi = null;
                if (tags) {
                    var pois = tags.filter(function (item) {
                        return item.category === 3;
                    });
                    if (pois.length) {
                        poi = pois[0];
                    }
                }
                scope.poi = poi;
                scope.getPoiDirections = getPoiDirections;
                function getPoiDirections(item) {
                    window.location.href = CONFIG.app.mapUrl + '?poiId=' + item.id;
                    return true;
                }
            }
        };
    }]);

}());